module.exports = __webpack_public_path__ + "static/imgs/center-bg.8a4aa41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/center-bg.jpg
// module id = AO6q
// module chunks = 1